<ng-container *ngIf="loaded">
  <app-tile-list *ngIf="tiles.length > 0" [tiles]="tiles" (tileClicked)="tileClicked.emit($event)"></app-tile-list>
  <p *ngIf="tiles.length === 0">{{'messages.pois.noSystemPOIs' | transloco}}</p>
</ng-container>
